export default __webpack_public_path__ + "static/media/foldsnd.55e0d15b.mp3";